import {
  Cluster,
  ClusterStats,
  type Renderer,
} from "@googlemaps/markerclusterer";

export class CustomClusterMarker implements Renderer {
  public render(
    {position, count}: Cluster,
    stats: ClusterStats,
    map: google.maps.Map,
  ) {
    const title = String(count),
      // adjust zIndex to be above other markers
      zIndex: number = Number(google.maps.Marker.MAX_ZINDEX) + count;

    const markerDiv = document.createElement("div");
    markerDiv.style.position = "relative";

    const markerCount = document.createElement("span");
    markerCount.style.position = "absolute";
    markerCount.style.left = "25px";
    markerCount.style.top = "20px";
    markerCount.style.color = "white";
    markerCount.style.fontSize = "14px";
    markerCount.style.fontWeight = "bold";
    markerCount.textContent = `${count}`;

    const markerImg = document.createElement("img");
    markerImg.style.position = "absolute";
    markerImg.src = "/img/maps/m1.png";

    markerDiv.append(markerImg);
    markerDiv.append(markerCount);

    const clusterOptions: google.maps.marker.AdvancedMarkerElementOptions = {
      map,
      position,
      zIndex,
      title,
      content: markerDiv,
    };
    return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
  }
}
